<!-- 库存销量分析 -->
<template>
  <div class="com-container">
    <div class="com-chart" ref="stock_ref"></div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      chartInstance: null,
      allData: null,
      currentIndex: 0, // 当前显示的数据
      timerId: null, // 定时器的标识
    };
  },
  mounted() {
    this.initChart();
    this.getData();
    window.addEventListener("resize", this.screenAdapter);
    this.screenAdapter();
  },
  destroyed() {
    window.removeEventListener("resize", this.screenAdapter);
    clearInterval(this.timerId);
  },
  methods: {
    initChart() {
      this.chartInstance = this.$echarts.init(this.$refs.stock_ref, "chalk");
      const initOption = {};
      this.chartInstance.setOption(initOption);
      this.chartInstance.on("mouseover", () => {
        clearInterval(this.timerId);
      });
      this.chartInstance.on("mouseout", () => {
        this.startInterval();
      });
    },
    async getData() {
      const { data: ret } = await axios.get("/left-bottom");
      this.allData = ret.data;
      this.updateChart();
      this.startInterval();
    },
    updateChart() {
      const centerArr = [
        ["20%", "20%"],
        ["40%", "20%"],
        ["60%", "20%"],
        ["80%", "20%"],
        ["20%", "52%"],
        ["40%", "52%"],
        ["60%", "52%"],
        ["80%", "52%"],
        ["30%", "80%"],
        ["50%", "80%"],
        ["70%", "80%"],
      ];
      const colorArr = [
        ["#0198FF", "#0348FF"],
        ["#E5DD45", "#E8B11C"],
        ["#E8821C", "#E55445"],
        ["#5052EE", "#AB6EE5"],
        ["#23E5E5", "#2E72BF"],
      ];
      // 处理图表需要的数据
      const titleFontSize = (this.$refs.stock_ref.offsetWidth / 100) * 3.6;
      const innerRadius = titleFontSize * 1.5;
      const outterRadius = innerRadius * 1.25;

      // const innerRadius = 25;
      // const outterRadius = 40;

      // const start = this.currentIndex * 5;
      // const end = (this.currentIndex + 1) * 5;
      // const showData = this.allData.slice(start, end);

      const seriesArr = this.allData.map((item, index) => {
        return {
          type: "pie",
          radius: [130, 100],
          center: centerArr[index],
          hoverAnimation: false, // 关闭鼠标移入到饼图时的动画效果
          labelLine: {
            show: false, // 隐藏指示线
          },
          radius: [innerRadius, outterRadius],
          label: {
            position: "center",
            color: "#00F7A6", // colorArr[index][0],
            fontSize: titleFontSize / 1.5,
          },
          data: [
            {
              name: item.name + "\n" + item.used+'%',
              value: item.used,
              itemStyle: {
                color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [
                  {
                    offset: 0,
                    color: colorArr[0][0],
                  },
                  {
                    offset: 1,
                    color: colorArr[0][1],
                  },
                ]),
              },
            },
            {
              value: item.noused,
              itemStyle: {
                color: "#262795",
              },
            },
          ],
        };
      });
      const dataOption = {
        series: seriesArr,
      };
      this.chartInstance.setOption(dataOption);
    },
    screenAdapter() {
      const titleFontSize = (this.$refs.stock_ref.offsetWidth / 100) * 3.6;
      const innerRadius = titleFontSize * 2;
      const outterRadius = innerRadius * 1.25;
      const adapterOption = {
        title: {
          textStyle: {
            fontSize: titleFontSize,
          },
        },
      };
      this.chartInstance.setOption(adapterOption);
      this.chartInstance.resize();
    },
    startInterval() {
      if (this.timerId) {
        clearInterval(this.timerId);
      }
      this.timerId = setInterval(() => {
        // this.currentIndex++;
        // if (this.currentIndex > 1) {
        // 	this.currentIndex = 0;
        // }
        this.updateChart(); // 在更改完currentIndex之后 , 需要更新界面
      }, 5000);
    },
  },
};
</script>

<style lang='less' scoped>
</style>
